import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fromReservation, fromLang } from 'store/selectors';

import { GuestText } from 'components';
import { AppText } from 'domain/appText';

const GuestCabinContainer = props => <GuestText {...props} />;

const mapStateToProps = (state, { guestId, departureId }) => {
  const selectedCabinId = fromReservation.getCabinByDepartureAndGuest(state, departureId, guestId);
  const collectIcePhoneNumber = fromReservation.collectIcePhoneNumber(state, departureId);
  const hasCabins = fromReservation.getCabinsByDeparture(state, departureId).length > 0;

  if (!selectedCabinId) {
    const noCabinSelectedLabel = !hasCabins && collectIcePhoneNumber ? '' : fromLang.t(state, AppText.NoCabinSelected, 'No cabin selected');
    return {
      valid: false,
      text: noCabinSelectedLabel,
    };
  }

  const { description, number } = fromReservation.getCabin(state, selectedCabinId);
  return {
    text: `${description}`,
    number: `${number}`,
    title: description,
    valid: true,
  };
};

GuestCabinContainer.propTypes = {
  guestId: PropTypes.string.isRequired,
  departureId: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(GuestCabinContainer);



// WEBPACK FOOTER //
// ./src/containers/GuestCabin.js